import React from 'react';
import styled from 'styled-components';
import {StyledCircle, StyledID, StyledName, tabletWidth} from '../../mixins';
import {formatID} from '../../common/helper';

const StyledSingleCircle = styled.div`
    ${StyledCircle()}
`

const StyledSingleName = styled(StyledName)`
    ${StyledName};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: auto;
    max-width: 55px;
    margin-right: 8px;
    
    @media screen and (min-width: ${tabletWidth}) {
     max-width: unset;
}
`

const SingleCircle = ({name, id}) => {

    const ID = formatID(id);

    return (
        <StyledSingleCircle>
            <StyledSingleName>{name}</StyledSingleName>
            <StyledID>{`ID: ${ID}`}</StyledID>
        </StyledSingleCircle>
    )
};

export default SingleCircle;